"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalCondition = void 0;
class MedicalCondition {
    constructor(props) {
        this.resourceType = "Condition";
        this.related_events = props?.related_events;
        this.code = props?.code;
        this.clinicalStatus = props?.clinicalStatus;
        this.related_conditions = props?.related_conditions;
        this.notes = props?.notes;
        this.verification_status = props?.verification_status;
        this.recordedDate = props?.recordedDate;
        this.recorder = props?.recorder;
        this.asserter = props?.asserter;
        this.encounter = props?.encounter;
        this.onsetDateTime = props?.onsetDateTime;
        this.onsetAge = props?.onsetAge;
        this.onsetPeriod = props?.onsetPeriod;
        this.onsetString = props?.onsetString;
        this.abatementDateTime = props?.abatementDateTime;
        this.abatementAge = props?.abatementAge;
        this.abatementPeriod = props?.abatementPeriod;
        this.abatementString = props?.abatementString;
    }
}
exports.MedicalCondition = MedicalCondition;
